export default __webpack_public_path__ + "static/media/Claw of the Death Master.7dbcf81c.jpg";